// src/pages/LoginPage.tsx
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../services/auth.service";
import { LoginRequest, User } from "../types/auth"; // Ensure LoginRequest is updated in types/auth.d.ts

interface LoginPageProps {
  setCurrentUser: (user: User | null) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ setCurrentUser }) => {
  const [email, setEmail] = useState<string>(""); // Changed from username
  const [password, setPassword] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setLoading(true);

    // Changed validation check
    if (!email || !password) {
      setMessage("Email and password are required!");
      setLoading(false);
      return;
    }

    try {
      // Pass email in the login request
      const user = await AuthService.login({ email, password }); // Changed from username
      setCurrentUser(user);
      navigate("/tasks");
    } catch (error: any) {
      const resMessage =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      setLoading(false);
      setMessage(resMessage);
    }
  };

  return (
    <div className="col-md-6">
      {/* <div className="container">
        <header className="">
          <h1>Welcome to Task Management App!</h1>
          <p>Your ultimate task management solution.</p>
          <p>Log in or register to manage your tasks efficiently.</p>
          <h2>Login</h2>
        </header>
      </div> */}

      <div className="card card-container">
        {/* <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        /> */}
        <header className="">
          <h1>Welcome to Task Management App!</h1>
          <p>Your ultimate task management solution.</p>
          {/* <p>Sign in or sign up to manage your tasks efficiently.</p> */}
          <h2>Sign in to your account</h2>
          <p>Use the following credentials to log in as a test user:</p>
          <p>Email: johndoe@example.com</p>
          <p>Password: 123456</p>
        </header>

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label htmlFor="email">Email</label> {/* Label changed to Email */}
            <input
              type="email" // Use type="email" for better browser validation hints
              className="form-control"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="form-group mt-3">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              className="form-control"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div className="form-group mt-3">
            <button className="btn btn-primary btn-block" disabled={loading}>
              {loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Sign in</span>
            </button>
          </div>

          {message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {message}
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
